// Secret Creamery — minimal AJAX add-to-cart + mobile nav
(function(){
  document.addEventListener('click',function(e){
    var m=e.target.closest('[data-menu-toggle]');if(m){m.closest('.sc-nav').classList.toggle('open');}
  });
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches('form[action*="/cart/add"]'))return;
    e.preventDefault();
    var btn=f.querySelector('[type="submit"]'),label=btn&&btn.textContent;
    fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'cart/add.js':'/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json()})
      .then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
      .then(function(c){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count});
        if(btn){btn.textContent='Added ♥';setTimeout(function(){btn.textContent=label},1400)}})
      .catch(function(){f.submit()});
  });
})();
